<template>
    <div id="TripWidgets">
        <v-card class="elevation-0 d-flex align-center justify-center" style="height: calc(100vh - 120px); overflow-x: hidden; overflow-y: auto">
            <div>
                <img src="../../assets/warning.png" width="150px" alt="no data" class="d-block mx-auto">
                <h4 class="text-center text-h6">No Trips Available</h4>
            </div>
        </v-card>
    </div>
</template>

<script>
  export default {
    name: 'TripWidgets',
    data () {
      return {
        widgets: [
          { id: 1, name: 'W1' }, { id: 2, name: 'W2' }, { id: 3, name: 'W3' },
          { id: 4, name: 'W4' }, { id: 5, name: 'W5' }, { id: 6, name: 'W6' },
          { id: 7, name: 'W7' }, { id: 8, name: 'W8' }, { id: 9, name: 'W9' },
        ],
      }
    },
  }
</script>

<style scoped>

</style>
